import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import TextField from "@mui/material/TextField";
import FormLabel from "@mui/material/FormLabel";
import FormGroup from "@mui/material/FormGroup";
import {
  Box,
  Grid,
  Checkbox,
  Divider,
  FormControlLabel,
  Typography,
  Autocomplete,
} from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import moment from "moment";
import Hosts from "./Hosts";
import Croninfo from "./Croninfo";
import Alert from "@mui/material/Alert";
import cron from "cron-validate";
import CustomDaypicker from "./CustomDaypicker";

var cronstrue = require("cronstrue");
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Days = [
  { id: 1, name: "Sunday", value: "SUN" },
  { id: 2, name: "Monday", value: "MON" },
  { id: 3, name: "Tuesday", value: "TUE" },
  { id: 4, name: "Wednesday", value: "WED" },
  { id: 5, name: "Thurday", value: "THU" },
  { id: 6, name: "Friday", value: "FRI" },
  { id: 7, name: "Saterday", value: "SAT" },
];

export default function Credentials(props) {
  const { open, Transition, setOpen } = props;

  const [templist, settemplist] = React.useState([[]]);

  React.useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/organizationtemplateslist/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
          window.localStorage.setItem("user_access", data.detail);
        } else {
          settemplist(data);
        }
      })
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);

  const [alertcheck, setAlertcheck] = React.useState(false);

  const [state, setState] = React.useState({
    name: "",
    execution_type: "scheduled",
    cron_expression: "",
    schedule_id: "",
    temp_id: "",
    hosts: "",
    start_date: "",
    start_time: "",
    cronvalue: "",
    repeat_frequency: "none",
    delete_id: "",
    errormessage: "",
  });

  const [schedulecheckstate, setSchedulecheckstate] = React.useState({
    checkedA: false,
  });

  const handleschedulecheckChange = (event) => {
    const name = "checkedA";
    setSchedulecheckstate({ [name]: event.target.checked });
  };

  const [frequencyday, setFrequencyDay] = React.useState();

  const handleChange = (e) => {
    const { id, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleChange1 = (event, value) => {
    const id = "cronvalue";
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const [hostlist, setHostlist] = useState([]);

  const handleProfileChange = (e) => {
    const { id, value } = e.target;
    var osValue;
    templist.map((val) => {
      if (parseInt(val.id) === parseInt(value)) {
        osValue = val.os_type;
      }
    });
    fetch(
      `${process.env.REACT_APP_API_URL}/api/organizationseperateoshostlist/${osValue}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + window.localStorage.getItem("token"),
        },
      }
    )
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
          window.localStorage.setItem("user_access", data.detail);
        } else {
          setHostlist(data);
        }
      })
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleSubmitClick = (e) => {
    e.preventDefault();
    setAlertcheck(false);
    console.log("trggered");
    //// Cron Expression /////
    var zone = "America/New_York";
    var datefmt = "MM-DD";
    var timefmt = "HH:mm";
    const startTime = state.start_time;
    var c = moment(startTime, timefmt, zone).utc().format(timefmt);
    const stTime = c.split(":");
    var startminutes = stTime[1];
    var starthours = stTime[0];

    if (state.cronvalue) {
      const onDays = state.cronvalue;

      const MaponDays = onDays
        .sort((a, b) => (a.id > b.id ? 1 : -1))
        .map((ondayvalue) => {
          const one = ondayvalue.value;
          return one;
        });
      const stringonDays = JSON.stringify(MaponDays);
      const onDaysreplace = stringonDays
        .replace("[", "")
        .replace("]", "")
        .replace(/"/g, "");
      var NewonDays = onDaysreplace;
    }

    const repeatFrequency = state.repeat_frequency;

    var cron_expression1;
    var cron_expression2;
    var depends_on;
    if (schedulecheckstate.checkedA) {
      depends_on = "during_training";
      if (repeatFrequency === "day") {
        cron_expression1 = `${startminutes} ${starthours} ${frequencyday[0]} ?`;
        cron_expression2 = `${startminutes} ${starthours} ${frequencyday[1]} ?`;
      } else {
        var NewstartDate;
        if (state.start_date) {
          NewstartDate = new Date(state.start_date);
        } else {
          const startDate = new Date().toISOString().substring(0, 10);
          NewstartDate = new Date(startDate);
        }

        var a = moment(NewstartDate, datefmt, zone).utc().format(datefmt);
        var sDate = new Date(a);
        const startmonths = sDate.getMonth() + 1;
        cron_expression1 = `${startminutes} ${starthours} ? ${startmonths} ${NewonDays}`;
      }
    } else {
      depends_on = "always";
      cron_expression1 = `${startminutes} ${starthours} * * ?`;
    }

    const hostvalues = JSON.stringify(state.hosts);
    const register = {
      name: state.name,
      depends_on: depends_on,
      repeat_frequency: repeatFrequency,
      cron_exp1: cron_expression1,
      cron_exp2: cron_expression2,
      profile: state.temp_id,
      hosts: hostvalues,
    };
    console.log(register);
    fetch(`${process.env.REACT_APP_API_URL}/api/schedule/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
      body: JSON.stringify(register),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.id) {
          window.location.reload();
        }
        if (data.name) {
          setOpen(!open);
        }
        window.location.reload();
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleClose = () => {
    setOpen(false);
  };

  function refreshPage() {
    const id1 = "name";
    const id2 = "cron_expression";
    const id3 = "delete_id";
    const id4 = "errormessage";
    setState(() => ({
      [id1]: "",
      [id2]: "",
      [id3]: "",
      [id4]: "",
    }));
    setOpen(false);
  }

  var currentTime = new Date();

  var currentOffset = currentTime.getTimezoneOffset();
  var ISTOffset = 330; // IST offset UTC +5:30
  var ISTTime = new Date(
    currentTime.getTime() + (ISTOffset + currentOffset) * 60000
  );
  var hoursIST = ISTTime.getHours();
  var minutesIST = ISTTime.getMinutes();
  var currentDate = new Date().toISOString().substring(0, 10);
  let DateTimeformat = `${currentDate}`;

  let localTime = new Date();
  let minDate1 = moment(localTime).format("YYYY-MM-DDTHH:MM");

  let startTimelocal = new Date(state.start_date_time);
  let startday = (startTimelocal.getDate() + 1).toString().padStart(2, "0");
  let startmonth = (startTimelocal.getMonth() + 1).toString().padStart(2, "0");

  let startyear = startTimelocal.getFullYear();
  let maxDate1 = `${startyear}-${startmonth}-${startday}`;

  let Dateformat = new Date(DateTimeformat);
  let currentDateTime = `${hoursIST}:${minutesIST}`;

  var nextMonth = ((Dateformat.getMonth() + 1) % 12) + 1;
  var cMonth = Dateformat.getMonth() + 1;

  if (cMonth === 12) {
    var year = currentTime.getFullYear() + 1;
    var date = new Date(`${year}`, `${nextMonth}`, 0);
    var endDate = date.getDate();
    var maxDate = `${year}-${nextMonth}-${endDate}`;
  } else {
    var year = currentTime.getFullYear();
    var date = new Date(`${year}`, `${nextMonth}`, 0);
    var endDate = date.getDate();
    var maxDate = `${year}-${nextMonth}-${endDate}`;
  }
  var maxDateFinal = new Date(maxDate).toISOString().substring(0, 10);

  return (
    <>
          
      <Dialog
        PaperProps={{
          sx: {
            width: "100%",
          },
        }}
        maxWidth={"md"}
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle
          style={{
            textAlign: "center",
            fontSize: "18px",
            fontWeight: "810",
            color: "rgb(48, 68, 115)",
            fontFamily: "sans-serif",
            lineHeight: "4.5rem",
          }}
        >
          ADD SCHEDULE
        </DialogTitle>
              
        {alertcheck ? (
          <Alert severity="error">Invalid Cron Expressions!!!</Alert>
        ) : (
          ""
        )}
        <DialogContent>
          <FormGroup>
            <FormLabel htmlFor="name">
              <strong>Name</strong>
            </FormLabel>

            <TextField
              fullWidth
              type="text"
              id="name"
              className="form-control"
              value={state.name}
              onChange={handleChange}
              variant="outlined"
              size="small"
              placeholder="Enter a name for the schedule"
            />
          </FormGroup>
          <br />
          <FormGroup>
            <FormLabel htmlFor="cron_expression">
              <strong>Schedule</strong>
            </FormLabel>
            <TextField
              fullWidth
              name="start_time"
              id="start_time"
              type="time"
              onChange={handleChange}
              required
              variant="outlined"
              InputProps={{
                style: {
                  height: "40px",
                },
              }}
            />
          </FormGroup>
          <br />
          <Box border={1}>
            <Accordion square expanded={schedulecheckstate.checkedA}>
              <AccordionSummary>
                <FormControlLabel
                  aria-label="Acknowledge"
                  control={
                    <Checkbox
                      disabled={state.start_time ? false : true}
                      checked={schedulecheckstate.checkedA}
                      onChange={handleschedulecheckChange}
                      value="checkedA"
                      color="secondary"
                    />
                  }
                  label={
                    <React.Fragment>
                      <FormLabel htmlFor="cron_expression">
                        <strong>During Time Period</strong>
                        <small>
                          ( AutomateCIS will be running at given frequencies
                          between the schedule provided )
                        </small>
                      </FormLabel>
                    </React.Fragment>
                  }
                />
              </AccordionSummary>
              <AccordionDetails>
                <Box sx={{ pb: 2, pt: 2 }}>
                  <FormLabel htmlFor="cron_expression">
                    <strong>Frequency Details</strong>
                  </FormLabel>
                  <Divider />
                </Box>
                <Typography variant="h8" gutterBottom>
                  Repeat Frequency
                </Typography>
                <TextField
                  fullWidth
                  name="repeat_frequency"
                  id="repeat_frequency"
                  onChange={handleChange}
                  disabled={schedulecheckstate.checkedA ? false : true}
                  required
                  select
                  SelectProps={{ native: true }}
                  autoComplete="repeat_frequency"
                  InputProps={{
                    style: {
                      height: "40px",
                    },
                  }}
                  sx={{ pb: 3 }}
                >
                  {" "}
                  <option key="" value=""></option>
                  <option key="day" value="day">
                    Specific Day's
                  </option>
                  <option key="week" value="week">
                    Weekly
                  </option>
                </TextField>
                {state.repeat_frequency === "day" ? (
                  <Grid sx={{ pb: 3 }}>
                    <Typography variant="h8" gutterBottom>
                      Choose the Required Dates
                    </Typography>
                    <CustomDaypicker
                      setFrequencyDay={setFrequencyDay}
                      startDate={state.start_date}
                    />
                  </Grid>
                ) : (
                  ""
                )}
                {state.repeat_frequency === "week" ? (
                  <Grid sx={{ pb: 3 }}>
                    <Typography variant="h7" gutterBottom>
                      Date
                    </Typography>
                    <TextField
                      fullWidth
                      name="start_date"
                      id="start_date"
                      type="date"
                      onChange={handleChange}
                      required
                      variant="outlined"
                      disabled={schedulecheckstate.checkedA ? false : true}
                      inputProps={{
                        min: minDate1,
                        max: `${maxDateFinal}T00:00`,
                      }}
                      InputProps={{
                        style: {
                          height: "40px",
                        },
                      }}
                    />
                    <br />
                    <Typography variant="h8" gutterBottom>
                      On Days
                    </Typography>
                    <Autocomplete
                      multiple
                      name="on_days"
                      size="small"
                      limitTags={2}
                      options={Days}
                      onChange={handleChange1}
                      disabled={schedulecheckstate.checkedA ? false : true}
                      getOptionLabel={(option) => option.name}
                      renderInput={(params) => (
                        <React.Fragment>
                          <TextField
                            {...params}
                            variant="outlined"
                            placeholder="On Days"
                          />
                        </React.Fragment>
                      )}
                    />
                  </Grid>
                ) : (
                  ""
                )}
              </AccordionDetails>
            </Accordion>
          </Box>
          <br />

          <FormGroup>
            <FormLabel htmlFor="cron_expression">
              <strong>Profile</strong>
            </FormLabel>
            <TextField
              type="select"
              id="temp_id"
              className="form-control"
              value={state.temp_id}
              name="temp_id"
              onChange={handleProfileChange}
              placeholder="-- Select the Profile --"
              variant="outlined"
              size="small"
              select
              SelectProps={{ native: true }}
              fullWidth
            >
              <option>-- Select the Profile --</option>
              {templist.map((templist) => {
                return (
                  <React.Fragment>
                    <option value={templist.id}>
                      {templist.name} {templist.compliance}
                    </option>
                  </React.Fragment>
                );
              })}
            </TextField>
          </FormGroup>
          <br />
          <FormGroup>
            <FormLabel htmlFor="cron_expression">
              <strong>Hosts</strong>
            </FormLabel>
                  
            <Hosts hostlist={hostlist} setState={setState} />
          </FormGroup>
          <br />
        </DialogContent>
                
        <DialogActions>
             
          <button
            className="bg-blueGray-100 text-black font-bold active:bg-blueGray-600 uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            onClick={() => refreshPage()}
          >
            Cancel
          </button>
          <button
            className={
              state.name &&
              state.temp_id &&
              state.hosts &&
              state.start_time &&
              ((schedulecheckstate.checkedA &&
                (frequencyday || (state.start_date && state.cronvalue))) ||
                !schedulecheckstate.checkedA)
                ? "bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                : "bg-blueGray-200 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            }
            onClick={handleSubmitClick}
            disabled={
              state.name &&
              state.temp_id &&
              state.hosts &&
              state.start_time &&
              ((schedulecheckstate.checkedA &&
                (frequencyday || (state.start_date && state.cronvalue))) ||
                !schedulecheckstate.checkedA)
                ? false
                : true
            }
          >
            Create
          </button>
        </DialogActions>
              
      </Dialog>
    </>
  );
}